import React, { useEffect, useState } from "react";
import GlobalWrapper from "../../components/Wrapper/GlobalWrapper";
import { Box, Button } from "@mui/material";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import FromAndToDatePicker from "../../components/mui/FromAndToDatePicker";
import dayjs from "dayjs";
import GlobalMultiSelectNew from "../../components/mui/GlobalMultiSelectNew";
import GlobalDatagrid from "../../components/mui/DataGrid/GlobalDatagrid";
import { useLocation } from "react-router-dom";
import ToolTip from "../../components/ToolTip/ToolTip";
import { getStudentData } from "../../redux/features/srtSlice";

const SrtStudentDetailView = () => {
  const userProfile = JSON.parse(localStorage.getItem("cred")).profile;

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const croID = searchParams.get("croId");
  const projectId = searchParams.get("project_id");
  const fromdate = searchParams.get("fromDate");
  const todate = searchParams.get("toDate");

  const [fromDate, setFromDate] = useState(
    fromdate || dayjs().startOf("month").format("YYYY-MM-DD")
  );
  const [toDate, setToDate] = useState(
    todate || dayjs().endOf("month").format("YYYY-MM-DD")
  );

  const dispatch = useDispatch();

  const { studentdata, loading } = useSelector((state) => state.srt);
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;

  useEffect(() => {
    dispatch(
      getStudentData({
        page: pageNum,
        limit: gridSize,
        projectId: projectId,
        croId: croID,
        fromDate: fromDate,
        toDate: toDate,
      })
    );
  }, [dispatch, fromDate, toDate, projectId, pageNum, gridSize, croID]);

  const GridHead = [
    { field: "lead_name", headerName: "Student Name", width: 200 },
    { field: "lead_mob_no", headerName: "Mobile Number", width: 200 },
    {
      field: "lead_place",
      headerName: "Place",
      width: 200,
    },
    {
      field: "rescheduled_count",
      headerName: "Rescheduled Counts",
      width: 200,
    },
    {
      field: "course_name",
      headerName: "Course Name",
      width: 200,
    },
    {
      field: "subject_name",
      headerName: "Subject Name",
      width: 200,
    },
  ];

  return (
    <GlobalWrapper title={"Student Details"}>
      <Box sx={{ display: "flex", mb: 1, gap: "10px", flexDirection: "row" }}>
        <FromAndToDatePicker
          disabled={false}
          fromDate={fromDate}
          toDate={toDate}
          setFromDate={setFromDate}
          setToDate={setToDate}
        />
      </Box>
      <Box sx={{ width: "100%", padding: 0 }}>
        <GlobalDatagrid
          tableHead={GridHead}
          rows={studentdata}
          meta={studentdata?.meta?.totalRecords || 0}
          rowUniqueId="lead_id"
          loading={loading}
          rowClick={false}
        />
      </Box>
    </GlobalWrapper>
  );
};

export default SrtStudentDetailView;
